import { LoadingContainer } from 'peach/components'
import { ListSubroutes } from 'peach/router'
import { useParams } from 'react-router-dom'

import { useInternalConsentGet } from 'core/types'

const PersonConsents = () => {
  const { companyId, personId } = useParams<{
    companyId?: string
    personId?: string
  }>()

  const {
    data: consents,
    isLoading,
    error,
  } = useInternalConsentGet({
    companyId,
    personId,
  })

  return (
    <LoadingContainer error={error} isLoading={isLoading}>
      <ListSubroutes
        json={consents}
        page
        paramKey='consentId'
        title='Consents'
      />
    </LoadingContainer>
  )
}

export default PersonConsents
